export function ClearSegIcon({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Rounded square background — navy */}
      <rect width="100" height="100" rx="22" fill="#1B2B4B" />

      {/* House roof */}
      <path d="M50 20 L78 44 L22 44 Z" fill="white" opacity="0.95" />

      {/* House body - segmented into 3 layers to represent cost segregation */}
      <rect x="26" y="44" width="48" height="12" rx="1" fill="white" opacity="0.95" />
      <rect x="26" y="58" width="48" height="12" rx="1" fill="white" opacity="0.7" />
      <rect x="26" y="72" width="48" height="10" rx="2" fill="white" opacity="0.45" />
    </svg>
  );
}

export function ClearSegWordmark({ size = 20, color = '#1B2B4B' }) {
  return (
    <span style={{ fontSize: size, fontWeight: 700, letterSpacing: -0.5, color, fontFamily: "'Georgia', serif" }}>
      Clear<span style={{ color: '#2563EB' }}>Seg</span>
    </span>
  );
}

export function ClearSegFull({ iconSize = 36, textSize = 20, color = '#1B2B4B', gap = 10 }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap }}>
      <ClearSegIcon size={iconSize} />
      <ClearSegWordmark size={textSize} color={color} />
    </div>
  );
}
